import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import dt from '../../../shared/theme';

const Container = styled.section`
  display: flex;
  ${props => props.isExpanded && `
    display: block;
    padding: 0;
    border: none;
  `};
  flex-direction: ${props => (dt(props).theme.isLarge ? 'row' : 'column')};
  ${props => dt(props).theme.isLarge && !props.isExpanded && `
    align-items: center;
    padding: 8px 16px;
    border-color: ${dt(props).theme.secondaryColorLight};
    border-radius: 0 0 4px 4px;
    border-width: 0 1px 1px 1px;
    border-style: solid;
  `};
`;

const Header = styled.h3`
  font-size: ${props => (props.isExpanded ? 16 : 14)}px;
  ${props => (dt(props).theme.isLarge ? `
    padding: 5px 8px 4px 0;
    margin: 0 16px 4px 0;
  ` : `
    margin: 10px 4px;
  `)};
`;

const Paragraph = styled.p`
  margin: 0 0 4px 4px;
`;

export default function Expertise({
  profile, isOnWireSide, isExpanded, isOnContributorSearchResultPage,
}) {
  if (isOnWireSide || isOnContributorSearchResultPage || !profile.canPostWires) {
    return null;
  }

  return (
    <Container className="micro-profile-areas-of-expertise" isExpanded={isExpanded}>
      <Header isExpanded={isExpanded}>Expertise</Header>
      {profile.areasOfExpertise.length > 0
        ? (
          <ul className="tags --default">
            {profile.areasOfExpertise.map(area => (
              <li key={area.slug}>
                <a href={`/profiles/experts_in/${area.slug}`}>{area.name}</a>
              </li>
            ))}
          </ul>
        )
        : <Paragraph>No areas of expertise</Paragraph>}
    </Container>
  );
}

Expertise.propTypes = {
  profile: PropTypes.shape({
    canPostWires: PropTypes.bool,
    areasOfExpertise: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string,
      name: PropTypes.string,
    })),
  }).isRequired,
  isExpanded: PropTypes.bool,
  isOnWireSide: PropTypes.bool,
  isOnContributorSearchResultPage: PropTypes.bool,
};

Expertise.defaultProps = {
  isExpanded: false,
  isOnWireSide: false,
  isOnContributorSearchResultPage: false,
};
